import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import guardianQueryService from '../services/guardianQueryService';
import styles from '../assets/guardianQueryCreate.module.css';

const GuardianQueryCreate = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    description: '',
  });
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.description.trim()) {
      toast.error('Please enter a description for your query');
      return;
    }

    setSubmitting(true);
    try {
      const response = await guardianQueryService.createQuery(formData);

      // Always show success if we get here (no error thrown)
      toast.success(
        response.message || 'Your query has been submitted successfully!'
      );
      navigate('/guardian-queries');
    } catch (error) {
      console.error('Error submitting query:', error);
      toast.error(error.message || 'Failed to submit query. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.guardianQueryCreate}>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.colMd12}>
            <div className={styles.panelTitle}>
              <h3>Guardian Query System</h3>
            </div>
            <div className={styles.panelGroup}>
              <div className={styles.colMd12}>
                <p className={styles.introText}>
                  Welcome to our Guardian Query System! This platform is
                  designed to help you get all the information you need before
                  becoming a guardian with us. Here's how it works:
                </p>

                <h3 className={styles.sectionTitle}>How It Works?</h3>

                <ol className={styles.orderedList}>
                  <li>
                    Ask Questions: Use the system to ask any questions you have
                    about becoming a guardian.
                  </li>
                  <li>
                    Real-Time Responses: Our team will respond to your queries
                    in real time, similar to a WhatsApp chat.
                  </li>
                  <li>
                    Record of Queries: All your questions and our responses are
                    recorded for your reference.
                  </li>
                </ol>

                <h3 className={styles.sectionTitle}>What You Can Ask About</h3>

                <ul className={styles.unorderedList}>
                  <li>
                    Application Process: Get details on how to apply and what to
                    expect.
                  </li>
                  <li>
                    Property Information: Learn more about the properties we
                    manage.
                  </li>
                  <li>
                    Guardian Responsibilities: Understand your role and duties
                    as a guardian.
                  </li>
                  <li>
                    Support Services: Inquire about the support available to
                    you.
                  </li>
                </ul>

                <p className={styles.conclusionText}>
                  We're here to help you every step of the way. Start your
                  conversation now and get the answers you need!
                </p>

                <div className={styles.formSection}>
                  <label className={styles.formLabel}>
                    Description <span className={styles.required}>*</span>
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className={styles.formControl}
                    rows={5}
                    placeholder="Enter your query here..."
                    required
                    disabled={submitting}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.colMd12}>
            <div className={styles.panelTitle}>
              <h3>Confirmation</h3>
            </div>
            <div className={styles.panelGroup}>
              <div className={styles.colMd12}>
                <div className={styles.buttonContainer}>
                  <button
                    type="button"
                    className={styles.submitButton}
                    onClick={handleSubmit}
                    disabled={submitting}
                  >
                    <span className={styles.plusIcon}>+</span>
                    {submitting ? ' Submitting...' : ' Submit question'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuardianQueryCreate;
